
import React, { useEffect, useState } from "react";

const SaleBanner = () => {
  const endTime = new Date().getTime() + 23 * 60 * 60 * 1000;

  const [time, setTime] = useState({ h: 0, m: 0, s: 0 });

  const calculateTime = () => {
    const now = new Date().getTime();
    const diff = endTime - now;

    if (diff <= 0) return { h: 0, m: 0, s: 0 };

    return {
      h: Math.floor(diff / (1000 * 60 * 60)),
      m: Math.floor((diff / (1000 * 60)) % 60),
      s: Math.floor((diff / 1000) % 60),
    };
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(calculateTime());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="w-full py-6 px-4 bg-gradient-to-br from-blue-50 via-sky-100 to-indigo-100 relative overflow-hidden">

      {/* 🔥 Background Glow */}
      <div className="absolute top-0 left-0 w-72 h-62 bg-blue-300 opacity-20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-72 h-62 bg-indigo-300 opacity-20 blur-3xl rounded-full"></div>

      <div className="relative max-w-7xl mx-auto">

        {/* 💻 DESKTOP */}
        <div className="hidden md:flex items-center justify-between gap-10 bg-white/70 backdrop-blur-xl border border-blue-100 rounded-3xl shadow-xl p-10">

          {/* LEFT */}
          <div className="flex-1">
            <h2 className="text-3xl font-bold text-blue-900 mb-3">
              Lappy Shop Flash Sale
            </h2>

            <span className="inline-block px-6 py-2 rounded-full bg-blue-700 text-white text-sm font-semibold mb-6 animate-pulse">
              SALE ENDS IN
            </span>

            {/* TIMER */}
            <div className="flex gap-4 mb-6">
              {[
                { label: "HRS", value: time.h },
                { label: "MIN", value: time.m },
                { label: "SEC", value: time.s },
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-white border border-blue-200 rounded-2xl px-6 py-4 shadow"
                >
                  <div className="text-3xl font-bold text-blue-700">
                    {item.value.toString().padStart(2, "0")}
                  </div>
                  <div className="text-xs text-gray-500 text-center">
                    {item.label}
                  </div>
                </div>
              ))}
            </div>

            {/* COUPON */}
            <div className="flex items-center gap-4">
              <div className="bg-blue-600 text-white px-6 py-2 rounded-full font-semibold shadow">
                LAPPY100
              </div>

              <p className="text-gray-600 text-sm">
                Apply at checkout
              </p>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex-1 space-y-4">
            <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 flex items-center gap-3">
              <div className="bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center">
                💸
              </div>
              <div>
                <p className="font-semibold text-gray-800">
                  Up to 70% Lower Prices
                </p>
                <p className="text-xs text-gray-500">
                  Compared to new devices
                </p>
              </div>
            </div>

            <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 flex items-center gap-3">
              <div className="bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center">
                🛡️
              </div>
              <div>
                <p className="font-semibold text-gray-800">
                  1+1 Year Warranty
                </p>
                <p className="text-xs text-gray-500">
                  Peace of mind guaranteed
                </p>
              </div>
            </div>
          </div>

        </div>

        {/* 📱 MOBILE */}
        <div className="md:hidden w-full max-w-md mx-auto bg-white/80 backdrop-blur-xl border border-blue-100 rounded-2xl shadow-lg p-6 text-center">

          <h2 className="text-xl font-bold text-blue-900 mb-2">
            Lappy Shop
          </h2>

          <div className="mb-5">
            <span className="px-5 py-1.5 rounded-full bg-blue-700 text-white text-sm font-semibold animate-pulse">
              SALE ENDS IN
            </span>
          </div>

          <div className="flex justify-center gap-3 mb-6">
            {[
              { label: "Hrs", value: time.h },
              { label: "Min", value: time.m },
              { label: "Sec", value: time.s },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white border border-blue-200 rounded-xl px-4 py-3 w-20 shadow-sm"
              >
                <div className="text-2xl font-bold text-blue-700">
                  {item.value.toString().padStart(2, "0")}
                </div>
                <div className="text-xs text-gray-500">
                  {item.label}
                </div>
              </div>
            ))}
          </div>

          <div className="mb-5">
            <p className="text-gray-600 text-sm">Use Code</p>
            <div className="mt-2 inline-block bg-blue-600 text-white px-6 py-2 rounded-full font-semibold">
              LAPPY100
            </div>
          </div>

          <p className="text-gray-500 text-sm">
            Apply at checkout to unlock savings
          </p>

        </div>

      </div>
    </div>
  );
};

export default SaleBanner;